import ShortCutDisplay from "../../../../src/components/ShortcutDisplay";
import PolypaneIntro from "../../../../src/components/PolypaneIntro";
import projectoverview from "../../../../assets/images/docs/projects/selector.png";
import bookmarksoverview from "../../../../assets/images/docs/projects/bookmarks.png";
import snippetspanel from "../../../../assets/images/docs/snippets/snippets.png";
import liquidglassicon from "../../../../assets/videos/blogs/pp27/liquidglassicon.mp4";
import linenumbers from "../../../../assets/images/blogs/pp27/linenumbers.png";
import forcestartingstyle from "../../../../assets/images/blogs/pp27/forcestartingstyle.png";
import alternates from "../../../../assets/images/blogs/pp27/alternates.png";
import * as React from 'react';
export default {
  ShortCutDisplay,
  PolypaneIntro,
  projectoverview,
  bookmarksoverview,
  snippetspanel,
  liquidglassicon,
  linenumbers,
  forcestartingstyle,
  alternates,
  React
};